import React, { Component } from 'react';

import type { ErrorBoundaryProps, ErrorBoundaryState } from 'components/ErrorBoundary/type';

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(_error: Error, _errorInfo: React.ErrorInfo) {
    // Error logged internally by React Error Boundary
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div>
          <div>Something went wrong.</div>
          {import.meta.env.DEV && this.state.error?.message ? (
            <pre>{this.state.error.message}</pre>
          ) : null}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
